<template>
   <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="12" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Product Management</h6>
        </b-col>
        <b-col cols="12" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <b-row>
        <b-col xl="12">
          <b-card no-body>
            <b-card-body>
              <b-tabs content-class="mt-3">
                <b-tab title="Subscriber Products" active>
                  <SubscriberProducts></SubscriberProducts>
                </b-tab>
                <b-tab title="NSIM GT" v-if="isProductAdmin || isPortalAdmin">
                  <Nsim></Nsim>
                </b-tab>
                <b-tab title="NSIM Rules">
                    <NsimRules></NsimRules>
                </b-tab>
                <b-tab title="Load NSIM GT" v-if="isProductAdmin || isPortalAdmin">
                    <LoadNsimGT></LoadNsimGT>
                </b-tab>
                <b-tab title="Short Codes">
                    <ShortCodes></ShortCodes>
                </b-tab>
                <b-tab title="Load Short Codes" v-if="isProductAdmin || isPortalAdmin">
                    <LoadShortCodes></LoadShortCodes>
                </b-tab>
              </b-tabs>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
    </b-container>
  </div>
</template>

<script>
    import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
    import SubscriberProducts from './SubscriberProducts';
    import Nsim from './Nsim';
    import NsimRules from './NsimRules';
    import LoadNsimGT from './LoadNsimGT';
    import ShortCodes from './ShortCodes';
    import LoadShortCodes from './LoadShortCodes.vue';
    import initService from '../../../../common/api-services/init-service';
    export default {
      name: "Product-Management",
      components: {
        RouteBreadCrumb,
        SubscriberProducts,
        Nsim,
        NsimRules,
        LoadNsimGT,
        ShortCodes,
        LoadShortCodes,
      },
      mounted() {
        document.title = 'Product Management'

        this.noAccess =
            !initService.getUserRoles().includes("Administrator") &&
            !initService.getUserRoles().includes("CARRIER_ADMIN") &&
            !initService.getUserRoles().includes("PORTAL_ADMIN ");

        //only show some tabs to a portal & product admin
        this.isProductAdmin = initService.getUserRoles().includes("PRODUCT_ADMIN")||initService.getUserRoles().includes("PORTAL_ADMIN");
        this.isPortalAdmin = initService.getPortalAdminRole();

        //don't do anything unless the user has access
        if (this.noAccess) {
          this.$router.push('/home');
        }

      },
      data() {
        return {
          noAccess: false,
          isProductAdmin: false,
          isPortalAdmin: false,
        }
      }
    }
</script>

<style scoped>

</style>
